module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main